import { loader } from 'graphql.macro'

export default function quickbooksTaxCodeRates ({ dataLoaders, queryKey }) {
  const [, haulerId] = queryKey
  const taxCodeRateSchema = loader('./quickbooksTaxCodeRates.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(taxCodeRateSchema, { haulerId })
}
